"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributesWithDisplayForms = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2023 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var uniqWith_1 = tslib_1.__importDefault(require("lodash/uniqWith"));
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var model_1 = require("../../../../../model");
function areAttributesWithDisplayFormsEqual(a, b) {
    return sdk_model_1.areObjRefsEqual(a.displayForm.ref, b.displayForm.ref);
}
function useAttributesWithDisplayForms(attributes) {
    var widgetRef = model_1.useDashboardSelector(model_1.selectSelectedWidgetRef);
    ts_invariant_1.default(widgetRef, "must have selected widget");
    var allAttributes = model_1.useDashboardSelector(model_1.selectAllCatalogAttributesMap);
    var allDisplayForms = model_1.useDashboardSelector(model_1.selectAllCatalogDisplayFormsMap);
    var incomingDisplayFormRefs = attributes.map(function (a) { return a.attributeHeader.ref; });
    var result = incomingDisplayFormRefs.reduce(function (result, ref) {
        var _a, _b;
        var displayForm = allDisplayForms.get(ref);
        if (!displayForm) {
            return result;
        }
        var attribute = allAttributes.get(displayForm.attribute);
        if (!attribute) {
            return result;
        }
        var linkDisplayForms = attribute.attribute.displayForms.filter(function (df) { return df.displayFormType === "GDC.link"; });
        (_a = result.linkDisplayForms).push.apply(_a, tslib_1.__spread(linkDisplayForms.map(function (df) { return ({
            attribute: attribute.attribute,
            attributeDisplayFormRef: ref,
            displayForm: df,
        }); })));
        (_b = result.allDisplayForms).push.apply(_b, tslib_1.__spread(attribute.attribute.displayForms.map(function (df) { return ({
            attribute: attribute.attribute,
            attributeDisplayFormRef: ref,
            displayForm: df,
        }); })));
        return result;
    }, {
        linkDisplayForms: [],
        allDisplayForms: [],
    });
    return {
        allDisplayForms: uniqWith_1.default(result.allDisplayForms, areAttributesWithDisplayFormsEqual),
        linkDisplayForms: uniqWith_1.default(result.linkDisplayForms, areAttributesWithDisplayFormsEqual),
    };
}
exports.useAttributesWithDisplayForms = useAttributesWithDisplayForms;
//# sourceMappingURL=useAttributesWithDisplayForms.js.map